import React from 'react';
import { Switch, Route } from 'react-router-dom';
import ApiDocsView from '../ApiDocsView';

const ApiDocsRoutes = (props) => {
  const { path } = props.match;
  return (
    <div>
      <Switch>
        <Route
          path={`${path}`}
          exact
          render={() => <ApiDocsView {...props} />}
        />
      </Switch>
    </div>
  );
};

export default ApiDocsRoutes;
